module.exports = new __parcel__URL__("warning.2f61946c.png").toString();